/* eslint-disable */
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Switch toggle - update a hidden field value
 * This is required as craft doesnt work well with native checkboxes...
 */

// Dependencies
import { initialiser } from '../utilitybelt';

var FormToggle = function FormToggle(config) {
  var _this = this;

  _classCallCheck(this, FormToggle);

  this.init = function () {
    if (!_this.switch || !_this.input) return;
    _this.bindEvents();
  };

  this.bindEvents = function () {
    _this.switch.addEventListener('click', _this.toggleSwitch);
  };

  this.toggleSwitch = function () {
    _this.switch.classList.toggle('is-checked');

    // for craft, the value needs to be 1 or undefined
    if (_this.input.value) {
      _this.input.value = null;
    } else {
      _this.input.value = 1;
    }
  };

  var el = config.el;

  this.switch = el;
  this.input = document.getElementById(this.switch.getAttribute('for'));
};

export default function(settings) {
  return initialiser(settings, FormToggle);
} 